import { modal } from '@codeleap/modals'
import { APIClient } from '@/services'
import { SearchGlobal } from './Search'
import React, { useCallback } from 'react'
import { AugmentedRenderItemInfo } from '@codeleap/web'
import { CommunityCardComponent } from '../Feed'
import { CommunitySearchFeed } from '@/types'
import { navigation } from '@/app'
import { HurdleCard } from '../Learn'

export const CommunitySearch = ({ onBack, isModal = false }) => {
  const [search, setSearch] = React.useState('')
  const { listProps } = APIClient.Community.useCommunitySearch(search)

  const handleCommunityPress = useCallback((communityId: string) => {
    if (isModal) onBack()
    window.location.href = navigation.getPathWithParams('Feed.Item', { id: communityId })
  }, [])

  const renderCommunityCard = useCallback(({ item }: AugmentedRenderItemInfo<CommunitySearchFeed>) => {
    if (item.type?.toLowerCase().includes('hurdle')) {
      return <HurdleCard module={{ title: 'Hurdle' } as any} onPress={() => handleCommunityPress(String(item.id))} />
    }

    return <CommunityCardComponent community={item} onPress={() => handleCommunityPress(String(item.id))} />
  }, [])

  return (
    <SearchGlobal
      onBack={onBack}
      listProps={listProps}
      renderCard={renderCommunityCard}
      onSearch={setSearch}
      search={search}
    />
  )
}

export const CommunitySearchModal = modal()
  .content(({ toggle }) => <CommunitySearch isModal onBack={toggle} />)
  .props({ variants: ['centered'], showClose: false })
